import { render, staticRenderFns } from "./ColorFamilyForm.vue?vue&type=template&id=3a16493b&"
import script from "./ColorFamilyForm.vue?vue&type=script&lang=js&"
export * from "./ColorFamilyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports